const all_1 = 2;
const first_1 = all_1 - 1;

const all_2 = 3;
const fist_2 = all_2 - 1;

const firstLast = {
  all: all_1,
  first: first_1,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
const middle = {
  all: all_2,
  first: fist_2,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
const onsite = {
  all: 100,
  first: 100,
  isFullAll: false,
  isFullFirst: false,
  people: { first: [], follow: [] },
};
let doctor = "李如浩";
const hours = {
  早診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "09:00-09:30": Object.assign({}, firstLast),
    "09:30-10:00": Object.assign({}, middle),
    "10:00-10:30": Object.assign({}, middle),
    "10:30-11:00": Object.assign({}, middle),
    "11:00-11:30": Object.assign({}, middle),
    "11:30-11:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
  午診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "15:00-15:30": Object.assign({}, firstLast),
    "15:30-16:00": Object.assign({}, middle),
    "16:00-16:30": Object.assign({}, middle),
    "16:30-17:00": Object.assign({}, middle),
    "17:00-17:30": Object.assign({}, middle),
    "17:30-17:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
  晚診: {
    doctor: doctor,
    show: false,
    isFullAll: false,
    isFullFirst: false,
    "18:00-18:30": Object.assign({}, firstLast),
    "18:30-19:00": Object.assign({}, middle),
    "19:00-19:30": Object.assign({}, middle),
    "19:30-20:00": Object.assign({}, middle),
    "20:00-20:30": Object.assign({}, middle),
    "20:30-20:50": Object.assign({}, firstLast),
    onsite: Object.assign({}, onsite),
  },
};

export const openTime = {
  hansheng: {
    週日: [],
    週一: [],
    週二: ["晚診"],
    週三: [],
    週四: ["晚診"],
    週五: ["午診", "晚診"],
    週六: ["早診"],
  },
  yoyo: {
    週日: [],
    週一: [],
    週二: [],
    週三: ["午診", "晚診"],
    週四: [],
    週五: [],
    週六: [],
  },
};

function generateFutureDaysWithWeeks(startDate, numberOfWeeks) {
  const daysOfWeek = ["週日", "週一", "週二", "週三", "週四", "週五", "週六"];
  let dates = {};
  let currentDate = new Date(startDate);

  for (let i = 0; i < numberOfWeeks * 7; i++) {
    let year = currentDate.getFullYear();
    let month = String(currentDate.getMonth() + 1).padStart(2, "0"); // 月份從0開始，所以需要+1
    let day = String(currentDate.getDate()).padStart(2, "0");
    let dateStr = `${year}-${month}-${day}`;
    dates[dateStr] = { week: daysOfWeek[currentDate.getDay()] };
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}

export const ondays = (startDate, numberOfWeeks, clinic_name) => {
  let futureDaysObject = generateFutureDaysWithWeeks(startDate, numberOfWeeks);
  // let doctor = openTime.doctor;
  Object.keys(futureDaysObject).forEach((date) => {
    futureDaysObject[date].hours = JSON.parse(JSON.stringify(hours));
    if (clinic_name === "all") {
      openTime.hansheng[futureDaysObject[date].week].forEach((time) => {
        futureDaysObject[date].hours[time].show = true;
      });
      openTime.yoyo[futureDaysObject[date].week].forEach((time) => {
        futureDaysObject[date].hours[time].show = true;
      });
    } else {
      openTime[clinic_name][futureDaysObject[date].week].forEach((time) => {
        // if clinic_name === 'yoyo' and data < 2024-09-12  or data === 2025-01-01 continue
        // if (
        //   [
        //     "2024-12-28",
        //     "2024-12-29",
        //     "2024-12-30",
        //     "2024-12-31",
        //     "2025-01-01",
        //     "2025-01-02",
        //   ].includes(date)
        // ) {
        //   return;
        // }
        // if (
        //   clinic_name === "yoyo" &&
        //   date === "2024-10-09" &&
        //   time === "午診"
        // ) {
        //   return;
        // }

        futureDaysObject[date].hours[time].show = true;
        // futureDaysObject[date].hours[time].doctor = doctor;
      });
    }
  });
  // console.log(futureDaysObject);
  return futureDaysObject;
};

//sortData: {2024-07-19: {…}, 2024-08-01: {…}, 2024-10-03: {…}, 2024-10-09: {…}, 2024-10-11: {…}, …}
